@use '../../styling/typography.scss' as *;

.DateTime {
  @extend %font-family-primary;
}
